import React from "react";
import { Box, Button, CircularProgress, Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import {
  PrimaryButton,
  PrimaryButtonHover,
  ButtonText,
} from "../../../styles/colors";
import { useSelector } from "react-redux";

export const FormButton = ({
  disabled,
  skipRoleCheck,
  onClickHandler,
  title,
  titleConfirm,
  step,
  startIcon,
  width,
  hoverBackgroundColor = PrimaryButtonHover,
  backgroundColor = PrimaryButton,
  titleColor = ButtonText,
  hoverTitleColor = "white",
  borderColor = PrimaryButton,
  borderTopRightRadius = 4,
  borderTopLeftRadius = 4,
  borderBottomLeftRadius = 4,
  borderBottomRightRadius = 4,
  backdropFilter = "none",
  height = 40,
  icon = null,
  loading = false,
  hoverBorderColor = null,
  loadingColor = "white",
  overRideButtonCheck = false,
  style,
  type = false,
  isSetting = false,
  loaderText,
}) => {
  const role = useSelector((state) => {
    if (state.user && state.user.role) {
      return state.user.role;
    }
    return null;
  });
  const isDisabled = () => {
    if (!overRideButtonCheck) {
      if (skipRoleCheck) {
        return false;
      } else {
        if (role === "manager" || role === "superadmin") {
          return false;
        } else {
          return true;
        }
      }
    } else {
      return disabled;
    }
  };
  const useStyles = makeStyles((theme) => ({
    buttonBackground: {
      width: width,
      color: titleColor,
      backgroundColor: loading ? hoverBackgroundColor : backgroundColor,
      border: `1px solid ${loading ? hoverBackgroundColor : borderColor}`,
      borderTopRightRadius,
      borderTopLeftRadius,
      borderBottomLeftRadius,
      borderBottomRightRadius,
      height: height,

      backdropFilter: backdropFilter,
      "&:hover": {
        backgroundColor: hoverBackgroundColor,
        border: `1px solid ${hoverBorderColor ? hoverBorderColor : hoverBackgroundColor
          }`,
        color: hoverTitleColor,
      },
    },
    circularProgress: {
      color: loadingColor,
    },
  }));

  const classes = useStyles();
  return (
    <Button
      style={{ marginRight: isSetting ? 0 : 10 }}
      disabled={isDisabled()}
      className={classes.buttonBackground}
      onClick={() => !loading && onClickHandler()}
      variant="outlined"
      type={type}
      startIcon={startIcon}
    >
      {loading ? (
        loaderText ? <Box display='flex' alignItems='center' width="100%">
          <CircularProgress size={20} sx={{ color: 'white', mx: 1, width: '50%' }} />
          <span style={{ color: 'white', textTransform: 'capitalize', width: '100%' }} component='span'>{loaderText}</span>
        </Box> : <CircularProgress size={20} sx={{ color: 'white', mx: 1 }} />
      ) : (
        <span className="button-title" style={style}>
          {title}
        </span>
      )
      }
    </Button >
  );
};
